/**
 * Created by admin on 2017/3/14.
 */

export const cookieUtils = function () {

};

function getCookieVal(offset) {
    var endstr = document.cookie.indexOf(';', offset);
    if (endstr == -1) {
        endstr = document.cookie.length;
    }
    return unescape(document.cookie.substring(offset, endstr));
};

cookieUtils.delCookie = function (name) {
    var Days = 1;
    var exp = new Date();
    exp.setTime(exp.getTime() - Days * 24 * 60 * 60 * 1000);
    let cookieStr = name + '= ; expires=' + exp.toGMTString() + '';
    //consoe.log.log(cookieStr+'');
    document.cookie = cookieStr;
};

cookieUtils.delRootCookie = function (name) {
    var Days = 1;
    var exp = new Date();
    exp.setTime(exp.getTime() - Days * 24 * 60 * 60 * 1000);
    let cookieStr = name + '=; expires=' + exp.toGMTString() + ';domain=gomelife.com;path=/';
    document.cookie = cookieStr;
};


cookieUtils.getCookie = function (name) {
    var arg = name + '=';
    var alen = arg.length;
    var clen = document.cookie.length;
    var i = 0;
    while (i < clen) {
        var j = i + alen;
        if (document.cookie.substring(i, j) == arg){
            return getCookieVal(j);
        }
        i = document.cookie.indexOf(' ', i) + 1;
        if (i == 0) {
            break;
        }
    }
    return null;
};

cookieUtils.setCookie = function (name, value) {
    var exp = new Date();
    exp.setTime(exp.getTime() + 60 * 1000 * 30);//过期时间 30分钟
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
};







// WEBPACK FOOTER //
// ./src/utils/cookieUtils.js